import styles from './sharePostPreview.module.less';
import { useSelector } from 'react-redux';
import { getProjectFromId } from '../projects-reducer';
import { SmallText, StrongText } from '@sb1/ffe-core-react';
import classNames from 'classnames';
import Spinner from '../../components/spinner/Spinner';
import useImgOnLoad from '../../components/hooks/useImgOnLoad';
import { isProjectADugnad } from '../project-model';
import { getSubprojectSharePath } from '../subproject-model';

const SharePostPreview = ({ projectId, subprojectId, className }) => {
    const [ref, loaded, onLoad] = useImgOnLoad();

    const project = useSelector((state) => getProjectFromId(state, projectId, true));
    const projectImageUrl = project.images?.img_urls?.cropped500 ?? project.img_url;

    let imageComponent;
    if (subprojectId) {
        imageComponent = (
            <>
                {!loaded && <Spinner className={styles.spinner} />}
                <img
                    className={classNames(styles.previewPhoto, styles.imageShare, !loaded && styles.hidden)}
                    src={`/api/public/project/${projectId}/subproject/${subprojectId}/shareImage`}
                    title={'Last ned og del'}
                    alt={'Delingsbilde'}
                    ref={ref}
                    onLoad={onLoad}
                />
            </>
        );
    } else {
        imageComponent = (
            <div className={styles.imageWrapper}>
                <div
                    style={{
                        backgroundImage: `url(${
                            projectImageUrl
                                ? projectImageUrl
                                : 'https://static.spleis.no/images/default-spleis-image.svg'
                        })`,
                    }}
                    className={styles.projectImage}
                />
            </div>
        );
    }
    return (
        <div className={[styles.container, className || ''].join(' ')}>
            {imageComponent}
            <div className={styles.textContainer}>
                <SmallText className={styles.link}>
                    {subprojectId
                        ? `spleis.no${getSubprojectSharePath({ projectId, subprojectId, isDugnad: isProjectADugnad(project) })}`
                        : 'spleis.no'}
                </SmallText>
                <StrongText className={styles.title}>{project.title}</StrongText>
            </div>
        </div>
    );
};

export default SharePostPreview;
